export default __webpack_public_path__ + "static/media/dark-round-checkmark.32f23b04.svg";